<template>
  <div class="main-header-status-bar">
    <span class="main-header-clock" @click="timeFormatConversion" style="cursor: pointer;">🕒 {{ currentTime }}</span>
    |
    <!-- <img
      :src="weatherImage"
      :title="nowWeather?.created_at + '\n' + nowWeather?.weather_value.weather[0].description"
      style="height: 40px; padding: -30px;"
      :style="getIsMobile() ? { height: '30px' } : {}"/> -->
    |
    <img src="@/assets/images/person.svg"/>{{ loginName }}
  </div>
</template>

<script setup>
import { isLoginUse } from "@/router";
// import { currentTime, decryptAES, getIsMobile, loginedUserData, nowWeather, timeFormatConversion, updateTime, weatherImage } from "@/utils/GlobalUtility";
import { currentTime, decryptAES, loginedUserData, timeFormatConversion, updateTime } from "@/utils/GlobalUtility";
// import { GET_SERVER_REQUEST } from "@/utils/ServerConnect";
import { nextTick, onMounted, onUnmounted, ref } from "vue";

const loginName = ref("");
let intervalTimer = null;

onMounted(async () => {
  await nextTick(async () => {
    const loginData = await loginedUserData();
    if (isLoginUse.value) loginName.value = loginData.user_name;
    else loginName.value = loginData.mltrEchlnCdNm + ' ' + decryptAES(loginData.mltrNm);
    
    updateTime();
    intervalTimer = setInterval(updateTime, 1000);

    // nowWeather.value = await GET_SERVER_REQUEST('weather');
  })
});
onUnmounted(() => {
  nextTick(() => {
    if (intervalTimer) clearInterval(intervalTimer);
  })
});
</script>
